/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class CauseService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'CauseService\' loaded');
    }
}

export { CauseService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/CauseService.js